<style lang="less" scoped>
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .ohnaebus-container {
    background-color: #fafaf1;
  }
  .in-sec {
    width: 1200px; margin: 0 auto;
    height: 800px; position: relative;
  }
  .car {
    position: absolute; top: 260px; left: 310px; z-index: 1;
    width: 399px; height: 370px; background: url(~@/assets/car-1-1.png) no-repeat;
  }
  .tree {
    position: absolute; z-index: 2;
    width: 75px; height: 123px; background: url(~@/assets/tree-1.png) no-repeat;
    &.tree-1 {
      top: 416px; left: 256px;
    }
    &.tree-2 {
      top: 526px; left: 447px;
    }
  }
  .sign {
    position: absolute; top: 212px; left: 604px; z-index: 0;
    width: 68px; height: 172px; background: url(~@/assets/sign-1.png) no-repeat;
  }
  h2 {
    font-size: 54px; color: #1170fe;
    padding-top: 112px;
    span {
      display: block; font-size: 20px; font-family: 'NotoSansKR_L';
      color: #222224; padding-top: 9px;
    }
  }
  ul {
    position: absolute; right: 0; top: 113px;
    width: 275px;
    li {
      strong {
        font-size: 18px; display: block; color: #222224; padding-bottom: 7px;
      }
      position: relative; letter-spacing: -.05em; padding: 26px 0;
      font-size: 14px; border-bottom: 1px solid #eeefe8; color: #505053;
      &:last-child {
        border-bottom: 0;
      }
      &::before {
        left: -100px; top: 10px;
        content: ''; position: absolute; width: 75px; height: 70px;
      }
      &.icon-1:before { background: url('~@/assets/icon-1.png') no-repeat; }
      &.icon-2:before { background: url('~@/assets/icon-2.png') no-repeat; }
      &.icon-3:before { background: url('~@/assets/icon-3.png') no-repeat; }
      &.icon-4:before { background: url('~@/assets/icon-4.png') no-repeat; }
      &.icon-5:before { background: url('~@/assets/icon-5.png') no-repeat; }
      &.icon-6:before { background: url('~@/assets/icon-6.png') no-repeat; }
    }
  }

  .animate-1 { transition-delay: .3s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-2 { transition-delay: .4s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-3 { transition-delay: .5s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-4 { transition-delay: .8s; transition-duration: .4s; transition-timing-function: ease-in; }
  .slide-down {
    opacity: 0;
    transform: translateY(-50px);
  }
  .slide-down.animate-active {
    opacity: 1;
    transform: translateY(0);
  }

  .slide-car {
    opacity: 0;
    transform: translate(-150px,-50px);
  }
  .slide-car.animate-active {
    opacity: 1;
    transform: translate(0,0);
  }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: auto; height: 520px;
    }

    .car {
      top: 37px; left: 10px;
      width: 150px; height: 140px;
      background-size: cover;
    }
    .tree {
      width: 23px; height: 37px;
      background-size: cover;
      &.tree-1 {
        top: 127px; left: 31px;
      }
      &.tree-2 {
        top: 165px; left: 105px;
      }
    }
    .sign {
      top: 41px; left: 142px;
      width: 24px; height: 60px;
      background-size: cover;
    }

    h2 {
      font-size: 27px; color: #1170fe;
      padding-top: 0; position: absolute; right: 15px; top: 50px;
      width: 174px;
      span {
        display: block; font-size: 10px; font-family: 'NotoSansKR_L';
        color: #222224; padding-top: 9px;
      }
    }

    ul {
      position: absolute; right: 10px; top: 113px;
      width: 144px;
      li {
        strong {
          font-size: 12px; display: block; color: #222224; padding-bottom: 7px;
        }
        position: relative; letter-spacing: -.05em; padding: 13px 0;
        font-size: 10px; border-bottom: 1px solid #eeefe8; color: #505053;
        &:last-child {
          border-bottom: 0;
        }
        &::before {
          left: -42px; .abs-tcenter;
          content: ''; position: absolute; width: 38px; height: 35px;
        }
        &.icon-1:before { background-size: cover; }
        &.icon-2:before { background-size: cover; }
        &.icon-3:before { background-size: cover; }
        &.icon-4:before { background-size: cover; }
        &.icon-5:before { background-size: cover; }
        &.icon-6:before { background-size: cover; }
      }
    }
  }
</style>

<template lang="pug">
  .ohnaebus-container
    .in-sec
      h2 오네버스 #[span IoT기반 어린이 안전 통원 솔루션]
      div.car.animate-4.slide-car(data-aos="fade")
      div.tree.tree-1.animate-1.slide-down(data-aos="fade-in")
      div.tree.tree-2.animate-2.slide-down(data-aos="fade-in")
      div.sign.animate-3.slide-down(data-aos="fade-in")
      ul
        li.icon-1
          strong 차량 잔류인원 비상 SMS
          span IoT 기반의 2중 안전장치 확보
        li.icon-2
          strong 슬립핑 차일드 체크 (엔젤버튼)
          span 슬립핑 차이드 체크 시스템으로 아이들의 안전 확보
        li.icon-3
          strong IoT기반 원아 위치 확인
          span 차량 승하차, 기관 등하원
        li.icon-4
          strong 실시간 차량 위치 확인
          span 실시간 조회로 학부모 차량 대기시간 감소
        li.icon-5
          strong 차량운행 관리일지
          span 차량 운행 이력을 통한 운행일지 자동관리
        li.icon-6
          strong 노선 정보 제공
          span 체계적인 노선관리, 노선 출력 기능 제공
      media(:mediaData="ohnaebus")
</template>

<script>
import Media from '@/components/Media.vue';

export default {
  props: {
    ohnaebus: {
      type: Object,
      default: null,
    },
  },
  components: {
    Media,
  },
};
</script>
